export * from './MainScreen';
export * from './UnAuthorized';
export {stackSplash, componentAction};

import AlertError from 'components/Alert/AlertError';
import AlertModal from 'components/Alert/AlertModal';
import DropdownModal from 'components/DropdownModal';
import ViewPDF from 'components/ViewPDF';
import {
  fadeInOut,
  translateXOptionsScreen,
  translateYModal,
} from 'container/optionsNavigate';
import ProgramDetailsModal from 'screens/MainScreen/AssetScreen/ProgramDetailsModal';
import FilterHistoryModal from 'screens/MainScreen/TransactionScreen/FilterHistoryModal';
import DigitalSignatureIPOScreen from './MainScreen/DigitalSignature/DigitalSignatureIPOScreen';
import DigitalSignatureScreen from './MainScreen/DigitalSignature/DigitalSignatureScreen';
import SignatureDraw from './MainScreen/DigitalSignature/SignatureDraw';
import SplashScreen from './SplashScreen';

const stackSplash = [
  {
    name: 'SplashScreen',
    component: SplashScreen,
  },
];

// const alert = {
//   name: 'AlertModal',
//   component: AlertModal,
// };

const componentAction = [
  {
    name: 'DropdownModal',
    component: DropdownModal,
  },
  {
    name: 'AlertModal',
    component: AlertModal,
    options: fadeInOut,
  },
  {
    name: 'AlertError',
    component: AlertError,
    options: fadeInOut,
  },
  {
    name: 'SignatureDraw',
    component: SignatureDraw,
    options: fadeInOut,
  },
  {
    name: 'ProgramDetailsModal',
    component: ProgramDetailsModal,
    options: fadeInOut,
  },
  {
    name: 'FilterHistoryModal',
    component: FilterHistoryModal,
    options: fadeInOut,
  },
  {
    name: 'ViewPDF',
    component: ViewPDF,
    options: translateYModal,
  },
  {
    name: 'DigitalSignatureScreen',
    component: DigitalSignatureScreen,
    options: translateXOptionsScreen,
  },
  {
    name: 'DigitalSignatureIPOScreen',
    component: DigitalSignatureIPOScreen,
    options: translateXOptionsScreen,
  },
];
